import controller from './user-modal-controller';
import template from './user-modal.html';

const userModalComponent = {
    bindings: {
        modalInstance: '<',
        resolve: '<'
    },
    controller,
    template
};

export default userModalComponent;



// WEBPACK FOOTER //
// ./app/components/user-admin/user-modal/user-modal-component.js